export default {
    methods: {
        initSelectableDate(period) {
            const nowDate = this.$moment();

            this.endDayLimit = nowDate.format('YYYY-MM-DD');
            if (period === '1y') {
                this.startDayLimit = nowDate.subtract(1, 'years').add(1, 'days').format('YYYY-MM-DD');
            } else {
                this.startDayLimit = nowDate.subtract(parseInt(period, 10), 'days').format('YYYY-MM-DD');
            }
        },
        extractRangeDayFromPeriod(period) {
            const nowDate = this.$moment();
            this.endDay = nowDate.format('YYYY-MM-DD');
            if (period === '1d') {
                this.startDay = nowDate.format('YYYY-MM-DD');
            } else if (period === '3d') {
                this.startDay = nowDate.subtract(2, 'day').format('YYYY-MM-DD');
            } else if (period === '7d') {
                this.startDay = nowDate.subtract(6, 'day').format('YYYY-MM-DD');
            } else {
                this.startDay = nowDate.subtract(29, 'day').format('YYYY-MM-DD');
            }

            this.rangeDay = [this.startDay, this.endDay];
            this.period = period;
        },
        setUtcStartEndDateTime(option) {
            this.startDate = this.$moment(`${this.startDay} 00:00:00`).utc().format('YYYY-MM-DD HH:mm:ss');

            if (option === 'shift') {
                this.endDate = this.$moment(`${this.endDay} 00:00:00`).add(1, 'd').utc().format('YYYY-MM-DD HH:mm:ss');
            } else {
                this.endDate = this.$moment(`${this.endDay} 23:59:59`).utc().format('YYYY-MM-DD HH:mm:ss');
            }
        },
        notRangedDate(date) {
            return date <= new Date(this.startDayLimit) || date >= new Date(this.endDayLimit);
        },
        renderDatetime(dateStr) {
            return (dateStr !== '') ? this.$moment.tz(dateStr, this.getLoginAccount.timezone).format('YYYY-MM-DD HH:mm:ss') : '';
        },
        renderDate(dateStr) {
            return (dateStr !== '') ? this.$moment.tz(dateStr, this.getLoginAccount.timezone).format('YYYY-MM-DD') : '';
        },
    },
    watch: {
        rangeDay(newValue, oldValue) {
            if (typeof newValue === 'object' && newValue.length === 2) {
                [this.startDay, this.endDay] = [newValue[0], newValue[1]];
            }
        },
    },
};
